import React from "react";
import DocViewer from "../../DocViewer/DocViewer";
import "../../DocViewer/Styles/DocViewerStyles.css";
import ChatContainer from "../../ChatListing/ChatContainer/ChatContainer";

export interface ViewerWrapperProps {
  selectedDocument: string;
  onBack?: () => void;
  pdfSummary?: string[] | string;
  fileName?: string;
}

const ViewerWrapper = ({
  selectedDocument,
  onBack,
  pdfSummary,
  fileName,
}: ViewerWrapperProps) => {
  return (
    <div className="flex h-full w-full space-x-4">
      <div className="custom-doc-viewer thin-scrollbar hidden md:flex md:w-2/5 xl:w-3/5">
        <DocViewer
          selectedDocument={selectedDocument}
          onBack={onBack}
          fileName={fileName}
        />
      </div>
      <div className="flex w-full items-center xl:w-2/5">
        <ChatContainer pdfSummary={pdfSummary} fileName={fileName} />
      </div>
    </div>
  );
};

export default ViewerWrapper;
